
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalog/product/[code]",
      function () {
        return require("private-next-pages/catalog/product/[code].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalog/product/[code]"])
      });
    }
  